const promotion = {
  page: {
    opening: "باز کردن مرکز تبلیغات",
    loading: "در حال بررسی نشست و بارگذاری داده‌های کمپین.",
    notice: "اعلان",
    errors: {
      settings: "بارگذاری تنظیمات سامانه ممکن نشد.",
      initialize: "راه‌اندازی مرکز تبلیغات ممکن نشد.",
    },
  },
  center: {
    campaignWorkspace: "فضای کاری کمپین",
    aiStudio: "استودیوی تبلیغات هوش مصنوعی",
  },
  common: {
    refresh: "به‌روزرسانی",
    optional: "اختیاری",
    unknown: "نامشخص",
    unknownType: "نوع نامشخص",
    unknownBot: "ربات نامشخص",
    unknownChannel: "نامشخص",
    bot: "ربات:",
    roles: { superAdmin: "مدیر ارشد", admin: "مدیر" },
    created: "ساخته‌شده در {{date}}",
    createdBy: "ساخته‌شده در {{date}} توسط {{username}}",
    startedCompleted: "شروع {{started}} · تکمیل {{completed}}",
    checked: "بررسی‌شده در {{date}}",
    total: "{{count}} کل",
    viewAll: "مشاهده همه",
    cancel: "لغو",
    delete: "حذف",
    enable: "فعال‌سازی",
    disable: "غیرفعال‌سازی",
    add: "افزودن",
    status: {
      draft: "پیش‌نویس",
      ready: "آماده",
      running: "در حال اجرا",
      completed: "تکمیل‌شده",
      partial: "ناقص",
      failed: "ناموفق",
      cancelled: "لغوشده",
    },
    contentMode: {
      original: "اصلی",
      teaser: "تیزر",
      ai: "آماده‌شده با هوش مصنوعی",
      custom: "سفارشی",
    },
    deliveryStatus: {
      pending: "در انتظار",
      in_progress: "در حال انجام",
      success: "موفق",
      failed: "ناموفق",
      skipped: "ردشده",
    },
    chatType: {
      channel: "کانال",
      group: "گروه",
      supergroup: "سوپرگروه",
    },
  },
  workspace: {
    loadingTitle: "در حال بارگذاری مرکز تبلیغات",
    loadingDescription: "کمپین‌ها، مقصدها و تاریخچه ارسال در حال همگام‌سازی هستند.",
    heroEyebrow: "مرکز تبلیغات",
    heroTitle: "فضای توزیع کمپین",
    heroDescription: "پست‌های جمع‌آوری‌شده را به کمپین‌های تبلیغاتی کنترل‌شده تبدیل کنید، به کانال‌ها و گروه‌های تأییدشده تلگرام ارسال کنید و فقط مقصدهای ناموفق را دوباره امتحان کنید.",
    loadErrorTitle: "داده‌های تبلیغات بارگذاری نشد",
    tabs: {
      overview: "نمای کلی",
      campaigns: "کمپین‌ها",
      create: "ساخت کمپین",
      targets: "مقصدهای تبلیغات",
      history: "تاریخچه ارسال",
    },
    stats: {
      campaigns: "کمپین‌ها",
      active: "فعال",
      completed: "تکمیل‌شده",
      attention: "نیازمند توجه",
    },
    recent: {
      title: "کمپین‌های اخیر",
      description: "آخرین فعالیت تبلیغاتی و وضعیت کمپین.",
      emptyTitle: "هنوز کمپینی وجود ندارد",
      emptyDescription: "اولین کمپین تبلیغاتی را از پست‌های جمع‌آوری‌شده تلگرام بسازید.",
      create: "ساخت کمپین",
    },
    readiness: {
      title: "آمادگی مقصدها",
      summary: "مقصد تأیید و برای اجرای کمپین آماده است",
      ready: "آماده",
      blocked: "مسدود",
      empty: "هنوز مقصد تبلیغاتی تنظیم نشده است.",
      review: "بررسی مقصدها ←",
    },
    create: {
      title: "ساخت کمپین تبلیغاتی",
      description: "ابتدا ساختار کمپین را ایجاد کنید. سپس پست‌ها را انتخاب، متن را آماده، مقصدها را تعیین و کمپین را از فضای کاری اجرا کنید.",
      name: "نام کمپین",
      namePlaceholder: "مثلاً مرور هفتگی فناوری",
      descriptionLabel: "توضیحات",
      descriptionPlaceholder: "یادداشت داخلی کمپین، هدف، مخاطب…",
      draftNote: "کمپین‌ها begin as پیش‌نویس. No Telegram messages are sent until you explicitly select verified targets and confirm launch.",
      action: "ساخت کمپین",
    },
    campaigns: {
      title: "کمپین‌ها",
      empty: "هنوز کمپینی وجود ندارد.",
      selectTitle: "یک کمپین انتخاب کنید",
      selectDescription: "یک کمپین را از فهرست باز کنید تا آن را آماده و منتشر کنید.",
      markReady: "علامت‌گذاری به‌عنوان آماده",
      backDraft: "بازگشت به پیش‌نویس",
      deleteAria: "حذف کمپین {{name}}",
      deliveries: "ارسال‌ها",
      succeeded: "موفق",
      failed: "ناموفق",
      warnings: "هشدارها",
    },
    posts: {
      addTitle: "افزودن پست جمع‌آوری‌شده",
      searchPlaceholder: "جست‌وجوی پست‌های جمع‌آوری‌شده بر اساس کانال، شناسه یا متن…",
      select: "یک پست جمع‌آوری‌شده انتخاب کنید ({{count}} نمایش داده شده)",
      aiNote: "AI mode uses prepared copy from استودیوی تبلیغات هوش مصنوعی or manually entered copy.",
      contentMode: "حالت محتوا",
      promotionText: "متن تبلیغاتی",
      aiPlaceholder: "متن تبلیغاتی آماده‌شده با هوش مصنوعی را اینجا وارد کنید.",
      textPlaceholder: "نسخه تبلیغاتی این پست را بنویسید…",
      cta: "دعوت به اقدام",
      ctaPlaceholder: "بیشتر بخوانید / به کانال بپیوندید…",
      sourceLink: "جایگزینی لینک منبع",
      save: "ذخیره متن",
      originalTitle: "پست اصلی جمع‌آوری‌شده",
      sourceUnavailable: "پست منبع در دسترس نیست.",
      preview: "پیش‌نمایش تلگرام",
      copyNotReady: "متن تبلیغاتی هنوز آماده نیست.",
      emptyTitle: "کمپین هیچ پستی ندارد",
      emptyDescription: "پیش از انتخاب مقصدهای تبلیغات، یک یا چند پست جمع‌آوری‌شده اضافه کنید.",
      editAria: "ویرایش پست کمپین",
      removeAria: "حذف پست کمپین",
    },
    launch: {
      title: "مقصدهای تبلیغات را انتخاب کنید",
      description: "فقط مقصدهای فعال و تأییدشده قابل انتخاب هستند. شکست یک مقصد مانع مقصدهای موفق نمی‌شود.",
      verified: "تأییدشده",
      noTargets: "هنوز مقصد تبلیغاتی وجود ندارد. مدیر ارشد باید پیش از اجرای کمپین حداقل یک مقصد را تنظیم و تأیید کند.",
      running: "این کمپین در حال اجرا است. ادامه کار از مجموعه مقصد اصلی ذخیره‌شده در backend استفاده می‌کند.",
      selected_one: "{{formattedCount}} مقصد انتخاب شده",
      selected_other: "{{formattedCount}} مقصد انتخاب شده",
      posts_one: "{{formattedCount}} پست کمپین",
      posts_other: "{{formattedCount}} پست کمپین",
      deliveries: "تا {{count}} ارسال",
      confirmHint: "برای تأیید انتشار دوباره فشار دهید",
      confirm: "تأیید اجرا",
      launch: "اجرای کمپین",
    },
    delivery: {
      title: "گزارش ارسال",
      description: "نتیجه هر مقصد و سوابق تلاش مجدد.",
      retrySelected: "تلاش دوباره برای انتخاب‌شده‌ها ({{count}})",
      retryAll: "تلاش دوباره برای همه ناموفق‌ها",
      headers: {
        status: "وضعیت",
        post: "پست",
        target: "مقصد",
        attempts: "تلاش‌ها",
        result: "نتیجه",
      },
      lastAttempt: "آخرین تلاش {{date}}",
      success: "با موفقیت منتشر شد",
    },
    targets: {
      addTitle: "افزودن مقصد کمپین",
      addDescription: "کانال یا گروه تلگرامی که کمپین‌ها می‌توانند در آن منتشر شوند را اضافه کنید. پیش از قابل انتخاب شدن مقصد، آزمایش اتصال لازم است.",
      name: "نام مقصد",
      namePlaceholder: "کانال خبری همکار",
      chatId: "شناسه گفتگوی تلگرام / @username",
      chatIdPlaceholder: "@channel or -100…",
      chatType: "نوع گفتگو",
      publishingBot: "ربات انتشار",
      selectBot: "حساب ربات را انتخاب کنید",
      disabledSuffix: "غیرفعال",
      credentialMissingSuffix: "اعتبار موجود نیست",
      botHelp: "ربات باید از قبل عضو/مدیر مقصد باشد و اجازه انتشار داشته باشد.",
      add: "افزودن مقصد",
      registerHelp: "توکن ربات شخصی را در مقصدها ذخیره کنید، سپس ربات را برای فضای کمپین خصوصی خود ثبت کنید.",
      register: "ثبت ربات مقصد من",
      listTitle: "مقصدهای کمپین",
      listDescription: "این کانال‌ها و گروه‌ها مجموعه مقصدهایی هستند که هنگام اجرای کمپین نمایش داده می‌شوند.",
      summary: "{{verified}} تأییدشده · {{total}} کل",
      ready: "آماده برای کمپین‌ها",
      needsVerification: "نیازمند تأیید",
      connectionError: "خطای اتصال",
      disabled: "غیرفعال",
      typeNotVerified: "نوع تأیید نشده",
      retest: "آزمایش دوباره",
      test: "آزمایش اتصال",
      emptyTitle: "هیچ مقصد کمپینی تنظیم نشده است",
      emptyDescription: "یکی از کانال‌ها یا گروه‌های تلگرام خود را در بالا اضافه کنید و سپس اتصال آن را آزمایش کنید.",
    },
    history: {
      title: "تاریخچه ارسال",
      description: "کمپین‌های تکمیل‌شده، ناقص و ناموفق به‌عنوان سابقه حسابرسی نگه‌داری می‌شوند. برای بررسی تلاش‌های جداگانه ارسال، کمپین را باز کنید.",
      emptyTitle: "هنوز تاریخچه ارسالی وجود ندارد",
      emptyDescription: "نتایج کمپین پس از نخستین اجرا اینجا نمایش داده می‌شوند.",
    },
    feedback: {
      refreshed: "فضای کاری تبلیغات به‌روزرسانی شد.",
      loadFailed: "بارگذاری داده‌های تبلیغات ممکن نشد.",
      campaignLoadFailed: "بارگذاری کمپین ممکن نشد.",
      nameRequired: "نام کمپین الزامی است.",
      created: "کمپین تبلیغاتی ساخته شد.",
      createFailed: "ساخت کمپین ممکن نشد.",
      marked: "وضعیت کمپین به «{{status}}» تغییر کرد.",
      updateFailed: "به‌روزرسانی کمپین ممکن نشد.",
      deleteConfirm: "کمپین پیش‌نویس «{{name}}» حذف شود؟",
      deleted: "کمپین حذف شد.",
      deleteFailed: "حذف کمپین ممکن نشد.",
      choosePost: "ابتدا یک پست جمع‌آوری‌شده انتخاب کنید.",
      postAdded: "پست به کمپین تبلیغاتی اضافه شد.",
      attachFailed: "افزودن پست ممکن نشد.",
      modeNeedsText: "حالت {{mode}} پیش از اجرا به متن تبلیغاتی نیاز دارد.",
      copySaved: "متن تبلیغاتی ذخیره شد.",
      copySaveFailed: "به‌روزرسانی متن تبلیغاتی ممکن نشد.",
      removePostConfirm: "این پست از کمپین حذف شود؟",
      postRemoved: "پست از کمپین حذف شد.",
      removePostFailed: "حذف پست کمپین ممکن نشد.",
      botRegistered: "ربات مقصد ذخیره‌شده اکنون برای کمپین‌های شخصی شما در دسترس است.",
      botRegisterFailed: "ثبت ربات مقصد برای کمپین‌ها ممکن نشد.",
      targetRequired: "نام مقصد، شناسه گفتگوی تلگرام و حساب ربات الزامی هستند.",
      targetCreated: "مقصد تبلیغاتی ساخته شد. پیش از استفاده در کمپین، اتصال را آزمایش کنید.",
      targetCreateFailed: "ساخت مقصد تبلیغاتی ممکن نشد.",
      targetVerified: "مقصد تبلیغاتی تأیید شد و برای کمپین‌ها آماده است.",
      targetVerificationFailed: "تأیید مقصد تبلیغاتی ناموفق بود.",
      targetEnabled: "مقصد تبلیغاتی فعال شد.",
      targetDisabled: "مقصد تبلیغاتی غیرفعال شد.",
      targetUpdateFailed: "به‌روزرسانی مقصد تبلیغاتی ممکن نشد.",
      targetDeleteConfirm: "مقصد تبلیغاتی «{{name}}» حذف شود؟ اگر برای سابقه حسابرسی ارسال لازم باشد، حذف آن مجاز نخواهد بود.",
      targetDeleted: "مقصد تبلیغاتی حذف شد.",
      targetDeleteFailed: "حذف مقصد تبلیغاتی ممکن نشد.",
      selectTarget: "حداقل یک مقصد تبلیغاتی تأییدشده انتخاب کنید.",
      delivered: "کمپین تبلیغاتی با موفقیت ارسال شد.",
      deliveryResults: "کمپین با نتایج ارسال پایان یافت. گزارش زیر را بررسی کنید.",
      launchFailed: "اجرای کمپین تبلیغاتی ممکن نشد.",
      selectFailed: "ارسال‌های ناموفق را برای تلاش دوباره انتخاب کنید.",
      retryFinished: "تلاش دوباره پایان یافت. گزارش ارسال به‌روزرسانی شد.",
      retryFailed: "تلاش دوباره برای ارسال‌های ناموفق ممکن نشد.",
      sessionChanged: "نشست تغییر کرده است. فضای کاری را دوباره باز کنید.",
      requestFailed: "درخواست تبلیغات ناموفق بود ({{status}}).",
    },
  },
  ai: {
    loading: "در حال بارگذاری استودیوی تبلیغات هوش مصنوعی",
    heroEyebrow: "موتور تبلیغات هوش مصنوعی",
    heroTitle: "تولید، بررسی و ذخیره",
    heroDescription: "Generate promotion-specific copy with the configured Gemini or OpenRouter model. نتیجهs stay editable and are never published automatically.",
    operationFailed: "عملیات هوش مصنوعی ناموفق بود",
    campaignPost: "پست کمپین",
    campaign: "کمپین",
    selectCampaign: "کمپین را انتخاب کنید",
    post: "پست",
    selectPost: "پست کمپین را انتخاب کنید",
    campaignState: "کمپین {{status}} · {{editing}} · نقش {{role}}",
    editingEnabled: "ویرایش با هوش مصنوعی فعال است",
    readOnly: "پس از شروع انتشار فقط خواندنی",
    generationControls: "کنترل‌های تولید",
    action: "عملیات هوش مصنوعی",
    writingStyle: "سبک نوشتار",
    outputLanguage: "زبان خروجی",
    outputLanguagePlaceholder: "انگلیسی",
    extraInstructions: "دستورهای اضافی",
    instructionsPlaceholder: "مخاطب، تأکیدها، طول دلخواه…",
    generate: "تولید {{action}}",
    backendNote: "ارائه‌دهنده و کلیدهای API در backend از تنظیمات موجود هوش مصنوعی تعیین می‌شوند. متن منبع به‌عنوان محتوای غیرقابل اعتماد در نظر گرفته می‌شود، نه دستور مدل.",
    generatedTitle: "نتیجه تولیدشده",
    generatedDescription: "پیش از اعمال روی متن کمپین، نتیجه را بررسی کنید.",
    generatedPlaceholder: "خروجی هوش مصنوعی اینجا نمایش داده می‌شود…",
    apply: "اعمال نتیجه در ویرایشگر",
    editorTitle: "ویرایشگر متن کمپین",
    editorDescription: "این متن برای انتشار بعدی در تلگرام ذخیره خواهد شد.",
    contentMode: "حالت محتوا",
    promotionText: "متن تبلیغاتی",
    cta: "دعوت به اقدام",
    ctaPlaceholder: "بیشتر بخوانید / به کانال بپیوندید…",
    save: "ذخیره در کمپین",
    preview: "پیش‌نمایش تلگرام",
    previewEmpty: "یک پست کمپین انتخاب کنید تا متن نهایی تبلیغاتی را پیش‌نمایش کنید.",
    styles: {
      professional: "حرفه‌ای",
      news: "خبری",
      educational: "آموزشی",
      friendly: "دوستانه",
      casual: "خودمانی",
      marketing: "بازاریابی",
      viral: "وایرال",
    },
    actions: {
      teaser: { label: "تیزر", help: "یک مقدمه کوتاه و جذاب بدون کلیک‌بیت ایجاد کنید." },
      rewrite: { label: "بازنویسی تبلیغاتی", help: "منبع یا پیش‌نویس فعلی را به متن تبلیغاتی حرفه‌ای تبدیل کنید." },
      shorten: { label: "کوتاه‌سازی", help: "متن کاری را کوتاه کنید و واقعیت‌های اصلی را حفظ کنید." },
      expand: { label: "گسترش", help: "ساختار و توضیح را بدون افزودن واقعیت جدید بهتر کنید." },
      translate: { label: "ترجمه", help: "با حفظ لینک‌ها، نام‌ها و قالب‌بندی، ترجمه‌ای دقیق انجام دهید." },
      cta: { label: "تولید دعوت به اقدام", help: "یک دعوت به اقدام کوتاه برای پست کمپین تولید کنید." },
      hashtags: { label: "تولید هشتگ", help: "۳ تا ۶ هشتگ مرتبط تلگرام ایجاد کنید." },
    },
    feedback: {
      selectPost: "ابتدا یک پست کمپین انتخاب کنید.",
      editableOnly: "AI generation is available only for پیش‌نویس or آماده campaigns.",
      chooseLanguage: "زبان مقصد ترجمه را انتخاب کنید.",
      generated: "{{action}} تولید شد. پیش از اعمال آن را بررسی کنید.",
      generationFailed: "تولید با هوش مصنوعی ناموفق بود.",
      applied: "نتیجه تولیدشده روی متن قابل ویرایش کمپین اعمال شد.",
      editOnly: "فقط پست‌های کمپین با وضعیت «پیش‌نویس» یا «آماده» قابل ویرایش هستند.",
      modeNeedsText: "حالت {{mode}} به متن تبلیغاتی نیاز دارد.",
      saved: "متن تبلیغاتی کمک‌گرفته از هوش مصنوعی در کمپین ذخیره شد.",
      saveFailed: "ذخیره متن تبلیغاتی ممکن نشد.",
      loadFailed: "بارگذاری استودیوی تبلیغات هوش مصنوعی ممکن نشد.",
      campaignLoadFailed: "بارگذاری کمپین ممکن نشد.",
      sessionChanged: "نشست تغییر کرده است. فضای کاری را دوباره باز کنید.",
      requestFailed: "درخواست هوش مصنوعی تبلیغات ناموفق بود ({{status}}).",
    },
  },
} as const;

export default promotion;
